import { createSlice } from '@reduxjs/toolkit'
import { getConsent } from 'api/consent'

const initialState = {
  consentId: '',
  consentConfig: '',
  loading: false,
  consentSections: {},
  receivedConsent: {},
  consentText: '',
  declarationConsent: []
}

export const consentReducer = createSlice({
  name: 'consentReducer',
  initialState,
  reducers: {
    setConsentId: (state, action) => {
      state.consentId = action.payload
    },
    setConsentConfig: (state, action) => {
      state.consentConfig = action.payload
    },
    setConsentSections: (state, action) => {
      state.consentSections = action.payload
    },
    setReceivedConsent: (state, action) => {
      state.receivedConsent = action.payload
    },
    setconsentText: (state, action) => {
      state.consentText = action.payload
    },
    setdeclarationConsent: (state, action) => {
      state.declarationConsent = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getConsent.pending, state => {
      state.loading = true
    })
    builder.addCase(getConsent.fulfilled, (state, action) => {
      state.loading = false;
      state.consentConfig = action.payload
      state.error = "success"
    })
    builder.addCase(getConsent.rejected, (state) => {
      state.loading = false
      state.error = "rejected"
    })
  }
})

// Action creators are generated for each case reducer function
export const {
  setConsentId,
  setConsentConfig,
  setConsentSections,
  setconsentText,
  setdeclarationConsent
} = consentReducer.actions

export default consentReducer.reducer